import { Convocation } from '@/manager/convocation/convocation.model';
import { TagInterface } from '@/manager/convocation/interfaces/tag.interface';
import { PaymentStatusInterface } from '@/manager/convocation/interfaces/paymentStatus.interface';
import { Participant, ParticipantMassiveEmail } from '@/manager/convocation/participant.model';
import { Note } from '@/manager/convocation/note.model';
import { Log } from '@/manager/convocation/log.model';
import { PostponementLog } from '@/manager/convocation/postponementLog.model';
import { TraspasementLog } from '@/manager/convocation/traspasementLog.model';
import { StatesConvocation } from '../state.model';

export interface State {
    list: Convocation[];
    paymentStatusList: PaymentStatusInterface[];
    participantList: Participant[];
    waitingList: Participant[];
    postpone: Participant[];
    repeaterList: Participant[];
    teamList: Participant[];
    tagList: TagInterface[];
    participantNoteList: Note[];
    participantLogList: Log[];
    participantPostponementLogList: PostponementLog[];
    participantTraspasementLogList: TraspasementLog[];
    convocationNoteList: Note[];
    nextConvocationList: Convocation[];
    convocationsStatesList: StatesConvocation[];
    participantListRequests: any[];
    participantMassiveEmailList: ParticipantMassiveEmail[];
    pendingPostpone: Participant[];
    countPostponeList: number;
    countWaitingList: number;
}

export const state: State = {
    list: [],
    paymentStatusList: [],
    participantList: [],
    waitingList: [],
    postpone: [],
    repeaterList: [],
    teamList: [],
    tagList: [],
    participantNoteList: [],
    participantLogList: [],
    participantPostponementLogList: [],
    participantTraspasementLogList: [],
    convocationNoteList: [],
    nextConvocationList: [],
    convocationsStatesList: [],
    participantListRequests: [],
    participantMassiveEmailList: [],
    pendingPostpone: [],
    countPostponeList: 0,
    countWaitingList: 0,
};
